import { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';
import { readItem, isOk } from '../../../utils/apiResult';

// Task 36 — TD Konfigürasyon sayfası: GET/PUT v1/talent-settings (Task 1/24
// sözleşmesi: 9-Box eşikleri, EmployeeCanSeeNineBox, potansiyel ağırlıkları
// (toplam-100), IDP SLA/bağlantı, succession periyodu, FlightRiskVisibleToManager).
// usePerformanceSettingsApi (Task 33) İLE AYNI ruh, ama PAYLAŞILAN önbellek YOK
// (usePerformanceSettings) — bu ayarları şu an yalnız bu sayfa tüketiyor
// (nine-box/development-plan akışları TalentSettings'i BE tarafında okuyor,
// FE'de ayrı bir tüketici yok), o yüzden basit fetch-per-mount yeterli.
export const useTalentSettingsApi = () => {
  const [settings, setSettings] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [saving, setSaving] = useState(false);
  // TD-23 (kalan yüzeyler, Faz 2) — bkz. utils/apiResult.js. Burada ayrım
  // ÖZELLİKLE tehlikeliydi: `settings === null` hem "yüklenemedi" hem "hiç
  // kaydedilmemiş (varsayılanlar)" anlamına geliyordu. Sayfa varsayılan formu
  // açıp KAYDET'e basıldığında kiracının gerçek eşiklerini varsayılanlarla
  // EZEBİLİYORDU. loadFailed artık formu bilerek engelliyor.
  const [loadFailed, setLoadFailed] = useState(false);

  const load = useCallback(() => {
    setFetching(true);
    return api.get('/v1/talent-settings')
      .then((res) => {
        setLoadFailed(!isOk(res));
        setSettings(readItem(res));
      })
      .finally(() => setFetching(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (payload) => {
    setSaving(true);
    try {
      await api.put('/v1/talent-settings', payload);
      await load();
      return true;
    } catch {
      return false;
    } finally {
      setSaving(false);
    }
  }, [load]);

  return {
    settings, fetching, saving, save, loadFailed,
  };
};

export default useTalentSettingsApi;
